import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  LayoutDashboard, CalendarClock, Users, Handshake, Camera,
  Wallet, Music, Bot, Radio, Bell, HelpCircle, User, LogOut, Heart,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const items = (eventId) => [
  { to: `/myevent/${eventId}`,          label: "MyEvent",       icon: LayoutDashboard, end: true },
  { to: `/myevent/${eventId}/planning`, label: "MyPlanning",    icon: CalendarClock },
  { to: `/myevent/${eventId}/guests`,   label: "MyGuests",      icon: Users },
  { to: `/myevent/${eventId}/pro`,      label: "MyPro",         icon: Handshake },
  { to: `/myevent/${eventId}/memories`, label: "MyMemories",    icon: Camera },
  { to: `/myevent/${eventId}/wallet`,   label: "MyWallet",      icon: Wallet },
  { to: `/myevent/${eventId}/music`,    label: "MyMusic",       icon: Music },
  { to: `/myevent/${eventId}/assistant`, label: "MyAssistant",  icon: Bot },
  { to: `/myevent/${eventId}/live`,     label: "MyLive",        icon: Radio },
];

const footer_items = [
  { to: "/espace-client/notifications", label: "Notifications", icon: Bell },
  { to: "#", label: "Aide & Support", icon: HelpCircle, soon: true },
  { to: "/espace-client/profil", label: "Mon compte", icon: User },
];

export default function MyEventSidebar() {
  const { pathname } = useLocation();
  const { eventId } = useParams();
  const { user, logout } = useAuth();
  const nav = items(eventId);

  return (
    <aside className="lg:col-span-3 lg:sticky lg:top-24 self-start">
      <nav className="card-luxe overflow-hidden" data-testid="myevent-sidebar">
        <div className="px-5 py-4 border-b border-[#DCB457]/15">
          <p className="text-[10px] uppercase tracking-[0.24em] text-[#DCB457] flex items-center gap-1.5">
            <Heart size={11} strokeWidth={1.5} /> MyEvent
          </p>
          <p className="text-[10px] text-white/40 mt-1 truncate">{user?.email}</p>
        </div>
        {nav.map(({ to, label, icon: Icon, end, soon }) => {
          const active = end ? pathname === to : (to !== "#" && pathname.startsWith(to));
          const testid = `sidebar-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
          if (soon) {
            return (
              <div key={label} data-testid={testid} className="flex items-center gap-3 px-5 py-3.5 text-sm border-b border-[#DCB457]/10 last:border-b-0 text-white/25 cursor-not-allowed">
                <Icon size={15} strokeWidth={1.3} />
                <span>{label}</span>
                <span className="ml-auto text-[9px] uppercase tracking-widest text-white/25">bientôt</span>
              </div>
            );
          }
          return (
            <Link key={label} to={to} data-testid={testid}
              className={`flex items-center gap-3 px-5 py-3.5 text-sm border-b border-[#DCB457]/10 last:border-b-0 ${
                active ? "bg-[#DCB457]/10 text-[#DCB457] border-l-2 border-l-[#DCB457]" : "text-white/70 hover:text-[#DCB457] hover:bg-[#DCB457]/5"
              }`}>
              <Icon size={15} strokeWidth={1.3} /> <span>{label}</span>
            </Link>
          );
        })}
      </nav>
      <nav className="card-luxe overflow-hidden mt-4">
        {footer_items.map(({ to, label, icon: Icon, soon }) => (
          soon ? (
            <div key={label} className="flex items-center gap-3 px-5 py-3 text-xs border-b border-[#DCB457]/10 last:border-b-0 text-white/25">
              <Icon size={13} strokeWidth={1.3} /> {label}
              <span className="ml-auto text-[9px] uppercase tracking-widest">bientôt</span>
            </div>
          ) : (
            <Link key={label} to={to} className="flex items-center gap-3 px-5 py-3 text-xs border-b border-[#DCB457]/10 last:border-b-0 text-white/60 hover:text-[#DCB457]">
              <Icon size={13} strokeWidth={1.3} /> {label}
            </Link>
          )
        ))}
        <button onClick={logout} data-testid="sidebar-logout"
          className="w-full text-left flex items-center gap-3 px-5 py-3 text-xs text-white/60 hover:text-[#DCB457]">
          <LogOut size={13} strokeWidth={1.3} /> Déconnexion
        </button>
      </nav>
    </aside>
  );
}
